import { render, staticRenderFns } from "./AdminActivityFeed.vue?vue&type=template&id=6a6ee1ca&scoped=true"
import script from "./AdminActivityFeed.vue?vue&type=script&lang=js"
export * from "./AdminActivityFeed.vue?vue&type=script&lang=js"
import style0 from "./AdminActivityFeed.vue?vue&type=style&index=0&id=6a6ee1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ee1ca",
  null
  
)

export default component.exports